<template>
  <v-container fill-height fluid style="height: 100vh">
    <v-row justify="center" align="center">
      <v-spacer />
      <v-col cols="12" style="text-align: center">
        <router-link to="/">
          <v-img :src="logo" width="97" height="60" style="display: inline-block" />
        </router-link>
      </v-col>
      <v-col cols="12">
        <div :class="contentClass" v-html="msg" />
      </v-col>
      <v-spacer />
    </v-row>
    <!-- <v-row justify="center" align="center">
      <v-spacer />
      <v-col cols="auto">
        <div :class="contentClass" v-html="msg" />
      </v-col>
      <v-spacer />
    </v-row> -->
  </v-container>
</template>

<script>
import logo from '@/assets/img/tape-logo.png'
import { chkWsDomain } from '@/services/api'
export default {
  created() {
    localStorage.removeItem('lastSelectedWsInfo')
    this.wsDomain = this.$route.query.wsDomain
    if (this.type !== 'mobile' && this.wsDomain && this.wsDomain !== null) this.checkWsDomain()
    else this.accessMsg()
  },
  name: 'NoAccess',
  props: ['type'],
  data() {
    return {
      logo: logo,
      msg: '',
      contentClass: '',
      wsIsNotExist: false,
      wsDomain: null,
    }
  },
  methods: {
    accessMsg() {
      switch (this.type) {
        case 'workspace':
          this.msg = this.wsIsNotExist ? this.$t('wsNotExistMsg') : this.$t('noAccessMsg')
          this.contentClass = 'no-access-content'
          return
        case 'channel':
          this.msg = `${this.$t('channelNoAccess1')}<br />${this.$t('channelNoAccess2')}`
          this.contentClass = 'no-access-content'
          return
        case 'mobile':
          this.msg = this.$t('notSupportedEnvMsgMobile')
          this.contentClass = 'no-access-mobile'
          return
      }
      return
    },
    async checkWsDomain() {
      // 워크스페이스 존재하지 않으면 존재하지 않는 페이지로 이동
      try {
        let result = await chkWsDomain(this, this.wsDomain)
        this.wsIsNotExist = result.body.isNotExist
        this.accessMsg()
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>
<style scoped>
.no-access-content {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  align-items: center;
  text-align: center;
  color: #96a7af;
}

.no-access-mobile {
  font-style: normal;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 2.5rem;
  align-items: center;
  text-align: center;
  color: #96a7af;
}
</style>
